import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const GridCell = ({
  classNames,
  children,
  s,
  m,
  l,
  sStart,
  mStart,
  lStart,
  justify
}) => (
  <div
    className={cn(
      'GridCell',
      {
        [`s-${s}`]: s,
        [`m-${m}`]: m,
        [`l-${l}`]: l,
        [`sStart-${sStart}`]: sStart,
        [`mStart-${mStart}`]: mStart,
        [`lStart-${lStart}`]: lStart,
        [`justify-${justify}`]: justify
      },
      classNames
    )}
  >
    {children}
  </div>
)

GridCell.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  s: PropTypes.number,
  m: PropTypes.number,
  l: PropTypes.number,
  sStart: PropTypes.number,
  mStart: PropTypes.number,
  lStart: PropTypes.number,
  justify: PropTypes.oneOf(['center'])
}

export default GridCell
